/**
 * 宣传专区
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} data
 * @returns
 */
export const SelectNewsById = (Id) => {
  return get('/api/app/News?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddNews = (data) => {
  return post('/api/app/News', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyNews = (data) => {
  return put('/api/app/News', data, {});
}

/**
 * 分页获取宣传专区
 * @param {*} data
 * @returns
 */
export const GetDataNewsList = (data) => {
  return post('/api/app/News/list', data, {});
}

/**
 * 链表分页查询
 * @param {*} data
 * @returns
 */
 export const GetDataByPageQuery = (data) => {
  return post('/api/app/News/getDataByPageQuery', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteNews = (id) => {
  return del('/api/app/News/' + id, {}, {});
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
 export const ExportNews = (data) => {
  let defaluturl = `/api/app/News/exportExcelFile`;
  let fileName = "宣传专区"
  return download(fileName, defaluturl, data);
}

/**
 * 根据id获取
 * @param {*} id
 * @returns
 */
 export const GetDataById = (id) => {
  return get('api/app/news/'+id+'/dataById');
}
